<div class="card-white blue-dark noMarginMovil">
  <div class="flex-container-nowrap w-100 initalContainer">
    <div class="titleSumary">
      <b>{{ 'k002525' | translate }}</b>
      <!-- Token: Portfolio adjusted to your risk profile is -->
    </div>
    <div class="flex-container-nowrap flex-align-center">
      <select
        class="ellipsis-tooltip ellipsis-tooltip myTooltip propety-select inp selectProfile c1 pointer ml-4"
        [(ngModel)]="simulationObj.ProfileId"
        [disabled]="!changeProfile"
        (ngModelChange)="profileIdChange($event)"
      >
        <option *ngFor="let profile of profiles" [value]="profile.ProfileCode">
          {{ profile.ProfileName }}
        </option>
      </select>
      <fa-icon
        *ngIf="infoProfileId"
        class="ml-2 pointer blue2"
        icon="info-circle"
        #infoProfileIdTooltip="matTooltip"
        (click)="viewInfoProfileId($event)"
        matTooltip="{{ 'k002526' | translate }}"
        matTooltipPosition="above"
        [matTooltipHideDelay]="1000"
      ></fa-icon>
      <!-- Token: This level of risk may not be right for you because the volatility and returns are not as expected. However, being below the previous you can invest in it. -->
    </div>
    
  </div>
  <div class="contentMp">
    <div id="grafMPdescribed">
      <tech-loading-peq></tech-loading-peq>
    </div>
    <div class="MpDescribed">
      <div class="MpDescribedItem" *ngFor="let item of series; let i = index">
        <div class="MpDescribedPorcent" [style.color]="this.colors[i]">
          <tech-count-span
            [number]="(item.data * 100).toFixed(0)"
            [totalTime]="1"
          ></tech-count-span
          >%
        </div>
        <span>{{ item.name }}</span>
      </div>
    </div>
  </div>
</div>
